import type { SphereAttachment } from 'types/attachment';

const CATEGORY_ICONS: Readonly<Record<string, string>> = {
  image: 'pi pi-image',
  video: 'pi pi-video',
  audio: 'pi pi-volume-up',
};

/**
 * Map a SphereAttachment to a PrimeIcon class string.
 * Links resolve to the link glyph; files are categorised by MIME type with a
 * generic file fallback.
 */
export function getIconClass(attachment: SphereAttachment): string {
  if (attachment.attachment_type === 'link') return 'pi pi-link';
  const mime = attachment.mime_type ?? '';
  const category = mime.split('/', 1)[0];
  const categoryIcon = CATEGORY_ICONS[category];
  if (categoryIcon) return categoryIcon;
  if (mime === 'application/pdf') return 'pi pi-file-pdf';
  if (mime.includes('word') || mime.includes('document')) return 'pi pi-file-word';
  if (mime.includes('excel') || mime.includes('spreadsheet')) return 'pi pi-file-excel';
  if (mime.includes('zip') || mime.includes('compressed')) return 'pi pi-folder';
  return 'pi pi-file';
}
